import { createContext, useContext } from 'react';
import type { PropsWithChildren } from 'react';
import type React from 'react';

import { useSignaturesDistributionContextValue } from './context';
import type { SignaturesDistributionContextValueType } from './context';
import type { MapConfiguration } from './types';

const SignaturesDistributionContext = createContext<SignaturesDistributionContextValueType>(
	null as unknown as SignaturesDistributionContextValueType,
);

export const SignaturesDistributionContextProvider: React.FC<
	PropsWithChildren<{ configuration: MapConfiguration }>
> = ({ configuration, children }) => {
	const value = useSignaturesDistributionContextValue(configuration);

	return <SignaturesDistributionContext.Provider value={value}>{children}</SignaturesDistributionContext.Provider>;
};

export const useSignaturesDistributionContext = () => {
	const value = useContext(SignaturesDistributionContext);

	return value;
};
